'use client';

import { FloatingButtonGroup, ScrollToTopButton } from '../../common/components';
import { BottomButtonWrapper } from '../../common/components/BottomButtonWrapper';
import { JoinEligibilityButton } from '../components/JoinEligibilityButton';

interface IntroCTASectionProps {
  disabled?: boolean;
}

export const IntroCTASection = ({ disabled = false }: IntroCTASectionProps) => (
  <BottomButtonWrapper data-cta-area className="bg-white">
    <div className="flex items-center justify-center py-3">
      <JoinEligibilityButton disabled={disabled} />
    </div>
    <FloatingButtonGroup.Container
      className="absolute -top-12 right-0"
      style={{
        // NOTE: translate-y-full 클래스가 적용되지 않음
        transform: 'translateY(-100%)',
      }}
    >
      <ScrollToTopButton />
    </FloatingButtonGroup.Container>
  </BottomButtonWrapper>
);
